<template>
    <div :class="['search-item-container', { active: isActive }]" @click="handleClick">
        <i :class="['icon', { 'icon--namecard': IsNameCard }]">
            <img v-if="IsLikeFollow" :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (unread ? 'favorite_Select.svg' : 'favorite.svg')" alt="Like/Follow" width="16" height="16" />
            <img v-if="IsInquiry" :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (unread ? 'Enquiry_Select.svg' : 'Enquiry.svg')" alt="查询" width="16" height="16" />
            <img v-if="IsMathed" :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (unread ? 'Post_match_Select.svg' : 'Post_match.svg')" alt="匹配" width="16" height="16" />
            <img v-if="IsRepyTo" :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (unread ? 'Post_reply_Select.svg' : 'Post_reply.svg')" alt="回复" width="16" height="16" />
            <img v-if="IsNameCard" :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (unread ? 'id_card_small_Select.svg' : 'id_card_small.svg')" alt="名片" width="16" height="16" />
        </i>
        <div class=text>
            <div class="title">
                <span :class="['name', { unread: unread }]">{{ title }}</span>
                <span class="date">{{ date }}</span>
            </div>
            <div :class="['content', { unread: unread, 'has-status-tag': showLikeFollowStatusTag }]">
                <span class="content-text">{{ content }}</span>
                <span
                    v-if="showLikeFollowStatusTag"
                    :class="['likefollow-status-tag', `status-${likeFollowStatusNormalized}`]"
                >
                    {{ likeFollowStatusText }}
                </span>
            </div>
        </div>
    </div>

</template>
<script>
import { isSalesLeadUnreadDate } from '@/_helpers/formatSalesLeadDate';

export default {
    props: [
        'title',
        'date',
        'content',
        'readDate',
        'isActive', //if true change background color
        'IsInquiry',
        "IsMathed",
        "IsRepyTo",
        "IsNameCard",
        "isAdmin",
        'IsLikeFollow',
        'status'
    ],
    data() {
        return {
            watched: false,
            ReadDate: this.readDate || this.ReadDate || '9999-12-31'
        }

    },
    computed: {
        unread() {
            const readDate = this.ReadDate || this.readDate;
            return isSalesLeadUnreadDate(readDate) && !this.watched;
        },
        langId() {
          return localStorage.getItem("currentLangId")
        },
        likeFollowStatusNormalized() {
          const raw = String(this.status || '').trim().toLowerCase();
          if (raw === 'pending') return 'pending';
          if (raw === 'accept' || raw === 'accepted') return 'accept';
          if (raw === 'reject' || raw === 'rejected') return 'reject';
          return '';
        },
        showLikeFollowStatusTag() {
          return this.IsLikeFollow && ['pending', 'accept', 'reject'].includes(this.likeFollowStatusNormalized);
        },
        likeFollowStatusText() {
          switch (this.likeFollowStatusNormalized) {
            case 'pending':
              return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ListStatus_Pending');
            case 'accept':
              return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ListStatus_Accept');
            case 'reject':
              return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ListStatus_Reject');
            default:
              return '';
          }
        },
      // countryName(){
      //     switch(this.langId){
      //         case('1252'):
      //             return this.countryName_eng
      //         case('950'):
      //             return this.countryName_trad
      //         default:
      //             return this.countryName_simp 
      //     }
      // },
      // title(){
      //     if(this.SalesLeadsType==0)
      //     {
      //         let temp = this.$t('lbl_EMPBE_SalesLead_fromCountry').replace('{buyerCountry}', this.countryName)
      //         return this.langId == 1252? this.companyName+temp:temp+this.companyName;
      //     }
      // }
    },
    watch: {
        //catch the event when user click other item
        isActive(newValue, value) {
            if (newValue == false && value == true && !this.isAdmin) {
                this.watched = true
                const readDate = this.ReadDate || this.readDate;
                if (isSalesLeadUnreadDate(readDate)) {
                    this.$emit('changeUnreadStatus')
                }
                // 注意：这里不更新 ReadDate，因为后端已经更新了，前端只需要标记为已观看
                // this.ReadDate = Date.now() // 注释掉，因为后端会更新 ReadDate
            }
        },
        readDate(newVal) {
            // 监听 prop 变化，同步到 data（当后端更新 ReadDate 后，前端列表也会更新）
            if (newVal) {
                this.ReadDate = newVal;
            }
        }
    },
    methods: {
        handleClick() {
            this.$emit('childClicked'); // Emit an event to the parent
        }
    }
}

</script>
<style lang="scss">
/* Used only in Sales Leads left list: keep left icon + right date/badge visible; ellipsize title/content */
.search-item-container {
    min-width: 0;
    display: flex;
    /* 与 .leftmenu --sl-list-row-inset-x / .leftmenu__footer 左内边距保持一致 */
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    transition: background-color 0.3s;
    width: 100%;
    cursor: pointer;

    &.active {
        background: #F1F0FF;
    }

    .icon {
        display: flex;
        width: 16px;
        height: 16px;
        padding: 1.667px 0.024px 1.65px 0px;
        justify-content: center;
        align-items: center;
        aspect-ratio: 1/1;
        flex-shrink: 0;

        &--namecard {
            width: 24px;
            height: 24px;
            padding: 0;
        }
    }

    .text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        flex: 1 1 auto;
        min-width: 0;


        .title {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            align-self: stretch;
            gap: 8px;
            min-width: 0;

            .name {
                display: block;
                align-items: center;
                gap: 4px;
                flex: 1 1 auto;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                /* Text/Headline 4 */
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                /* 21px */
                letter-spacing: -0.154px;

                &.unread {
                    font-weight: bold;
                }
            }

            .date {
                flex-shrink: 0;
                margin-left: 4px;
                padding-left: 4px;
                color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                font-feature-settings: 'liga' off, 'clig' off;
                /* Text/Paragraph 3 */
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                /* 18px */

            }
        }

        .content {
            overflow: hidden;
            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
            font-feature-settings: 'liga' off, 'clig' off;
            text-overflow: ellipsis;
            /* Text/Paragraph 3 */
            white-space: nowrap;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;
            /* 18px */
            width: 100%;
            max-width: 100%;
            min-width: 0;
            box-sizing: border-box;

            .content-text {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                min-width: 0;
            }

            .likefollow-status-tag {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                padding: 0 4px;
                line-height: 18px;
                font-size: 12px;
                font-weight: 600;
                color: #fff;
                flex: 0 0 auto;

                &.status-pending {
                    background: #FFD02C;
                    color: rgba(0, 0, 0, 0.8);
                }

                &.status-accept {
                    background: #51BB25;
                }

                &.status-reject {
                    background: rgba(0, 0, 0, 0.4);
                }
            }

            &.has-status-tag {
                display: flex;
                align-items: center;
                gap: 4px;
                width: 100%;

                .content-text {
                    flex: 1 1 auto;
                    min-width: 0;
                }
            }

            &.unread {
                font-weight: bold;
            }
        }


    }

}
</style>